module.exports = __webpack_public_path__ + "static/media/loading.665b98f1.gif";